import { render, staticRenderFns } from "./AdministrationDrawer.vue?vue&type=template&id=b60dda7a&"
import script from "./AdministrationDrawer.vue?vue&type=script&lang=js&"
export * from "./AdministrationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports